/** Alpha-aware contrast against the white icon backing; transparent black is not visible ink. */
export function hasVisibleFaviconPixels(pixels: ArrayLike<number>) {
  let visible = 0
  for (let i = 0; i < pixels.length; i += 4) {
    const contrast = ((765 - pixels[i] - pixels[i + 1] - pixels[i + 2]) * pixels[i + 3]) / 765
    if (contrast > 12) visible++
  }
  return visible > 0
}

export function isBlankLocalFavicon(img: HTMLImageElement) {
  try {
    if (new URL(img.currentSrc || img.src, location.href).origin !== location.origin) return false
    const canvas = document.createElement("canvas")
    canvas.width = 32
    canvas.height = 32
    const context = canvas.getContext("2d", { willReadFrequently: true })
    if (!context) return false
    context.drawImage(img, 0, 0, 32, 32)
    return !hasVisibleFaviconPixels(context.getImageData(0, 0, 32, 32).data)
  } catch {
    return false
  } // Cross-origin/unsupported canvases retain ordinary load/error fallback.
}
